<template>
	<div class="container">
		<div class="heading">
			<img src="/assets-dev/images/animaticons/animat-heart-color.gif" alt="Health Check" style="max-width:100px; float: left">
			<div id="title">
				<h4 class="mbn">Club Health Check</h4>
				<h5>More Bookings. Less Hassle.</h5>
			</div>

		</div>
		<div class="smsToggle grid-item">
			<ToggleWithLabel feature="sms" v-if="supportsSMS" setting="sms" label="SMS Invoices"  :disable-if-toggled-on="true" />
		</div>
		<div class="absorbToggle grid-item">
			<ToggleWithLabel feature="absorbCharges" setting="absorbCharges" label="Absorb Payments" :disable-if-toggled-on="true" />
		</div>
		<div class="premiumListingToggle grid-item">
			<ToggleWithLabel feature="listingsActive" v-if="supportsListingSite" setting="listingsActive" label="ClassForKids Discovery"  :disable-if-toggled-on="false" />
		</div>

		<div class="calculatorButton grid-item" v-if="percent && fixed && symbol">
			<a href="#"  data-reveal-id="calculator" class="button smaller success">{{ absorbText }}</a>
			<div id="calculator" class="reveal-modal small" data-reveal aria-labelledby="absorb Payments" aria-hidden="true" role="dialog">
				<h2 id="modalTitle">More Payments. Less Hassle.</h2>
				<p class="lead">
					When your club absorbs the fee parents see one simple price to pay and you will see a dramatic increase in your online payments. ClassForKids needs to charge for every transaction processed but we have a handy calculator to show just how little you'd need to put prices up by as well as showing you potential profits!
				</p>
				<SalesCalculatorCustomer :percent="percent" :fixed="fixed" :symbol="symbol" :stripePercent="stripePercent" />
				<a class="close-reveal-modal" aria-label="Close">&#215;</a>
			</div>
		</div>
	</div>
</template>


<script>
'use strict';

import ToggleWithLabel from './ToggleWithLabel';
import Toggle from './Toggle';
import SalesCalculatorCustomer from './SalesCalculatorCustomer';

export default {
  name: 'ClientHealthCheck',
  data() {
    return {
      loading: true
    };
  },

  methods: {},

  props: {
    percent: {
      required: false,
      type: Number,
      default: function() {
        return parseFloat(this.$root.$el.dataset.commisionPercent);
      }
    },

    stripePercent: {
      required: false,
      type: Number,
      default: function() {
        return parseFloat(this.$root.$el.dataset.commisionStripePercent);
      }
    },

    fixed: {
      required: false,
      type: String,
      default: function() {
        return this.$root.$el.dataset.fixedFee;
      }
    },
    symbol: {
      required: false,
      type: String,
      default: function() {
        return this.$root.$el.dataset.currencySymbol;
      }
    },
    absorbing: {
      required: false,
      type: Boolean,
      default() {
        return this.$root.$el.dataset.absorbing == 'true';
      }
    },

    supportsListingSite: {
      required: false,
      type: Boolean,
      default() {
        return this.$root.$el.dataset.supportsListingSite == 'true';
      }
    },

    supportsSMS: {
      required: false,
      type: Boolean,
      default() {
        return this.$root.$el.dataset.supportsSms == 'true';
      }
    }
  },

  computed: {
    absorbText() {
      return this.absorbing ? 'Calculate absorb payment amount. 🤓' : 'Need help with switching to absorb payments? 🤓';
    },
  },

  components: {
    ToggleWithLabel,
    SalesCalculatorCustomer,
    Toggle
  },

  beforeMount() {},

  mounted() {},
  created() {}
};
</script>


<style scoped lang="scss">
.container {
  display: grid;
  grid-row-gap: 16px;
  margin-top: 8px;
  margin-bottom: 8px;
  background: white;
  border-radius: 3px;
  border: 1px solid #ebebeb;
}

.grid-item {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

#title h4 {
	margin-bottom: 0.5em;
}

@media only screen {
  .heading {
    grid-column: 1 / span 3;
    grid-row: 1;
    display: flex;
    align-items: center;
  }
  .smsToggle {
    grid-column: 1 / span 1;
    grid-row: 2;
    padding: 0.5rem;
  }
  .absorbToggle {
    grid-column: 2 / span 1;
    grid-row: 2;
    padding: 0.5rem;
  }
  .premiumListingToggle {
    grid-column: 3 / span 1;
    grid-row: 2;
    padding: 0.5rem;
  }

  .calculatorButton {
    grid-column: 1 / span 3;
    grid-row: 3;
    padding: 1rem;
  }
}

@media only screen and (min-width: 40.063em) {
  .heading {
    grid-column: 1 / span 3;
    grid-row: 1;
    display: flex;
    align-items: center;
  }
  .smsToggle {
    grid-column: 4 / span 1;
    grid-row: 1;
    padding: 0.5rem;
  }
  .absorbToggle {
    grid-column: 5 / span 1;
    grid-row: 1;
    padding: 0.5rem;
  }
  .premiumListingToggle {
    grid-column: 6 / span 1;
    grid-row: 1;
    padding: 0.5rem;
  }

  .calculatorButton {
    grid-column: 7 / span 1;
    grid-row: 1;
    padding: 0.5rem;
  }
}
</style>
